import {Component, Input, OnInit} from '@angular/core';
import {SkillsCheckerModel} from '../../model/skills-checker.model';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../../../services/analytics.service';

@Component({
    selector: 'app-skills-card',
    templateUrl: './skills-card.component.html',
    styleUrls: ['./skills-card.component.scss'],
})
export class SkillsCardComponent implements OnInit {
    @Input() active = false;
    @Input() data: SkillsCheckerModel = null;

    constructor(
        private analytics: AnalyticsService,
        private router: Router) {
    }

    ngOnInit() {
    }

    openDevReport() {
        this.router.navigate(['/skills-checker/development/my', this.data.id]);
    }

    addSkillReport() {
        this.router.navigate(['/skills-checker/form/self', this.data.delegate.id, this.data.id]);
    }
}
